import { render, staticRenderFns } from "./ReactionList.vue?vue&type=template&id=620b821e&scoped=true&"
import script from "./ReactionList.vue?vue&type=script&lang=ts&"
export * from "./ReactionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b821e",
  null
  
)

export default component.exports